//noinspection JSHint
import $ from "jquery";

export default function ProductListFilterController() {
}

function toggleFilterLayer(event, options) {
  let filterOverlay = $(".js-activate-filter-layer");
  let filterLayerStatus = filterOverlay.attr("data-active-state");

  //there no events when restoring the layer state on filter selection
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  // To restore the current position, no transition can take place
  if (options && options.transition === "no-transition") {
    filterOverlay.css("transition", "none");
  }


  if (filterLayerStatus !== "closed") {
    filterOverlay.removeClass("product-filter--transition-end");
  } else {
    filterOverlay.one("transitionend", function () {
      filterOverlay.addClass("product-filter--transition-end");
    });
  }


  filterOverlay.toggleClass("product-filter--active");

  //toggle a class on the body
  toggleBodyFilterClass("open");

  //sets the layer to either open or closed
  if (filterLayerStatus !== "closed") {
    //close the view if it is active
    if (filterLayerStatus !== "open") {
      shrinkFilterView();
    }
    filterOverlay.attr("data-active-state", "closed");
    toggleBodyFilterClass("closed");
  } else {
    filterOverlay.attr("data-active-state", "open");
    toggleBodyFilterClass("open");
  }

  // to restore normal behaviour after restoring the position, the transition property has to be reset
  if (options && options.transition === "no-transition") {
    setTimeout(function wait() {
      filterOverlay.css("transition", "");
    }, 50);
  }
}

function expandFilterView(event, options) {
  let filterOverlay = $(".js-activate-filter-layer");
  let filterList = $(".product-filter__filter-list");

  //define the target name
  let currentFilterName =
      (event && event.currentTarget.attributes["data-filter-name"].value) ||
      (options && options.targetName);

  //get the corrosponding element
  let currentFilterElement = $(
      ".js-expand-filter-view[data-filter-name=" + currentFilterName + "]"
  )[0];

  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  // To restore the current position, no transition can take place
  if (options && options.transition === "no-transition") {
    filterList.css("transition", "none");
  }

  highlightCurrentFilter(currentFilterElement);
  toggleHeadline(options);
  toggleFilterView();

  filterOverlay.attr("data-active-state", currentFilterName);

  // to restore normal behaviour after restoring the position, the transition property has to be reset
  if (options && options.transition === "no-transition") {
    setTimeout(function wait() {
      filterList.css("transition", "");
    }, 50);
  }
}

function highlightCurrentFilter(currentFilter) {
  let filterInputClass = ".product-filter__filter-input";
  let filterActiveClass = "product-filter__filter--active";
  let filterTopLayerClass = "product-filter__filter--ontop";
  let allFilterElements = $(".product-filter__filter");
  let alreadyActive = false;

  //get the extenden view / aside element of the current filter (parameter)
  let currentFilterParent = $(currentFilter).parent()[0];
  let currentFilterInput = $(currentFilter).siblings(filterInputClass)[0];

  //check if class is already active
  if ($(currentFilterParent).hasClass(filterActiveClass)) {
    alreadyActive = true;
  }
  //deactivate all other Filters
  allFilterElements.removeClass(filterActiveClass);
  allFilterElements.removeClass(filterTopLayerClass);

  //move the activeFilter to the right hight
  toggleActiveFilterInView(currentFilterInput);

  if (!alreadyActive) {
    //only activate the current Filter if it wasnt active before
    $(currentFilterParent).addClass(filterTopLayerClass);
    $(currentFilterParent).addClass(filterActiveClass);
  }
}

function toggleFilterView() {
  let filterList = $(".product-filter__filter-list");
  let filterListActiveClass = "product-filter__filter-list--active";

  filterList.toggleClass(filterListActiveClass);
}

function toggleActiveFilterInView(filterElement) {
  let scrollParent = $(".product-filter__filter-container");
  let scroll = $(scrollParent).scrollTop();
  let windowWidth = $(window).width();
  let mobileViewBreakPoint = 480;

  if (windowWidth >= mobileViewBreakPoint) {
    return;
  }

  if (filterElement) {
    $(filterElement).css("top", scroll);
    $(scrollParent).css("overflowY", "hidden");
  } else {
    $(scrollParent).css("overflowY", "");
  }
}

function toggleHeadline(options) {
  let inactiveHeadline = $(".js-show-filter-headline").not(
      ".product-filter__headline--active"
  );
  let headlines = $(".js-show-filter-headline");
  let toggleHeadlineClass = "product-filter__headline--active";

  if (options && options.transition === "no-transition") {
    headlines.css("transition", "none");
  }

  $(headlines).removeClass(toggleHeadlineClass);

  $(inactiveHeadline).addClass(toggleHeadlineClass);

  if (options && options.transition === "no-transition") {
    setTimeout(function wait() {
      headlines.css("transition", "");
    }, 50);
  }
}

function deselectActiveFilter() {
  let filterActiveClass = "product-filter__filter--active";
  let filterTopLayerClass = "product-filter__filter--ontop";
  let filterActiveElement = $(".product-filter__filter--active");

  filterActiveElement.removeClass(filterActiveClass);
  filterActiveElement.removeClass(filterTopLayerClass);
}

function shrinkFilterView(event) {
  let filterOverlay = $(".js-activate-filter-layer");

  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  toggleActiveFilterInView();
  toggleFilterView();
  toggleHeadline();
  deselectActiveFilter();

  filterOverlay.attr("data-active-state", "open");
}

function jumpToPreviousPosition(position) {
  toggleFilterLayer(null, {transition: "no-transition"});

  if (position !== "open") {
    expandFilterView(null, {
      transition: "no-transition",
      targetName: position,
    });
  }
}

function toggleLoadingSpinner() {
  let spinner = $(".js-active-filter-spinner");
  let hiddenClass = "product-filter__loading--hidden";

  spinner.removeClass(hiddenClass);
}

function hideFilters(number) {
  let filterEntries = $(".js-filter-tiles");
  let hiddenClass = "product-filter__filter--hidden";

  filterEntries.each(function (index) {
    if (index >= number) {
      $(this).addClass(hiddenClass);
    }
  });
}

function showFilters() {
  let filterEntries = $(".js-filter-tiles");
  let hiddenClass = "product-filter__filter--hidden";

  filterEntries.removeClass(hiddenClass);
}

function toggleShowFilterButtons() {
  let filterButtons = $(".product-filter__show-filter-button");
  let filterButtonActiveClass = "product-filter__show-filter-button--active";

  filterButtons.toggleClass(filterButtonActiveClass);
}

function toggleMoreFilters() {
  let filterOverlay = $(".js-activate-filter-layer");
  let filterStatus = filterOverlay.attr("data-filter-state");

  //default case
  if (filterStatus === "mostImportant") {
    filterOverlay.attr("data-filter-state", "all");
    showFilters();
    //close button
  } else if (filterStatus === "all") {
    filterOverlay.attr("data-filter-state", "mostImportant");
    hideFilters(9);
  }

  toggleShowFilterButtons();
}

function preserveFilterAmount(filterAmountState) {
  let filterOverlay = $(".js-activate-filter-layer");

  filterOverlay.attr("data-filter-state", filterAmountState);
  showFilters();
  toggleShowFilterButtons();
}

function toggleBodyFilterClass(status) {
  let filterClass = "mobile-filter--active";

  if (status === "open") {
    $("body").addClass(filterClass);
  } else {
    $("body").removeClass(filterClass);
  }
}

ProductListFilterController.prototype.init = function (initOptions) {
  $(".js-open-filter-layer").off("click").on("click", toggleFilterLayer);
  $(".js-close-filter-layer").off("click").on("click", toggleFilterLayer);
  $(".js-expand-filter-view").off("click").on("click", expandFilterView);
  $(".js-shrink-filter-view").off("click").on("click", shrinkFilterView);
  $(".js-filter-checkbox-active").off("click").on("click", toggleLoadingSpinner);
  $(".js-show-more-filter").off("click").on("click", toggleMoreFilters);
  $(".js-show-less-filter").off("click").on("click", toggleMoreFilters);

  let position = initOptions && initOptions["data-active-state"];
  let filterAmountState = initOptions && initOptions["data-filter-state"];

  //on mobile: reopen filter position
  if (position && position !== "closed") {
    jumpToPreviousPosition(position);
  }

  //on desktop: remember filter amount state - "mostImportant" is the default
  if (filterAmountState && filterAmountState !== "mostImportant") {
    preserveFilterAmount(filterAmountState);
  }
};

